export const agenda = {
  agendaDuration: 'duration',
  agendaCurtainCopy: 'Copy link',
  agendaCurtainFlag: 'Flag content',
  agendaCurtainFlagSent: 'Content reported',
  agendaLinkCopied: 'Link copied!',
  agendaStartsAt: 'Starts at ',
  agendaEndsAt: 'Ends at ',
  agendaSpeakers: 'Speakers',
  agendaSeeAllSpeakers: 'See all',
  agendaAddToSchedule: 'Add to My Schedule',
  agendaRemoveFromSchedule: 'Remove from My Schedule',
  agendaAddedToSchedule: 'Added to My Schedule!',
  agendaRemovedFromSchedule: 'Removed from My Schedule!',
  agendaCalendar: 'Calendar',
  agendaAddToCalendar: 'Add to the system calendar?',
  agendaCalendarSkip: 'Skip',
  agendaCalendarAdd: 'Add',
  agendaNow: 'NOW',
  agendaModerators: 'Moderators'
}
